import { render, staticRenderFns } from "./SVGNavbarLogo.vue?vue&type=template&id=622232d2&scoped=true&"
import script from "./SVGNavbarLogo.vue?vue&type=script&lang=js&"
export * from "./SVGNavbarLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622232d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('622232d2')) {
      api.createRecord('622232d2', component.options)
    } else {
      api.reload('622232d2', component.options)
    }
    module.hot.accept("./SVGNavbarLogo.vue?vue&type=template&id=622232d2&scoped=true&", function () {
      api.rerender('622232d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGNavbarLogo.vue"
export default component.exports